import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { version } from '../../package.json';

export const datadogInit = () => {
  const config = {
    version,
    clientToken: 'pubadb7e34f625ebec7d87fd68f20076479',
    site: 'us3.datadoghq.com',
    service: 'supplier-portal',
    env: process.env.NODE_ENV,
    sessionSampleRate: 100
  };

  if (!datadogRum.getInternalContext()) {
    datadogRum.init({
      ...config,
      applicationId: '5d32d845-69ba-4dfc-8669-867820b4571d',
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input'
    });

    // TODO: Once application has user authentication implemented, set user for rum session here
    // if (user) {
    //   datadogRum.setUser({ id: '1234', name: 'John Doe' });
    // }
  }

  if (!datadogLogs.getInitConfiguration()) {
    datadogLogs.init({
      ...config,
      forwardErrorsToLogs: true
    });

    // TODO: Once application has user authentication implemented, set user for logs here
    // if (user) {
    //   datadogLogs.setUser({ id: '1234', name: 'John Doe' });
    // }
  }
};
